"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeOnboardingBodyToJSON = exports.ChallengeOnboardingBodyFromJSONTyped = exports.ChallengeOnboardingBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChallengeOnboardingBodyFromJSON(json) {
    return ChallengeOnboardingBodyFromJSONTyped(json, false);
}
exports.ChallengeOnboardingBodyFromJSON = ChallengeOnboardingBodyFromJSON;
function ChallengeOnboardingBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'onboardingSection': !(0, runtime_1.exists)(json, 'onboardingSection') ? undefined : (0, _1.ChallengeOnboardingFromJSON)(json['onboardingSection']),
        'faqs': !(0, runtime_1.exists)(json, 'faqs') ? undefined : (json['faqs'].map(_1.ChallengeFaqDetailsFromJSON)),
    };
}
exports.ChallengeOnboardingBodyFromJSONTyped = ChallengeOnboardingBodyFromJSONTyped;
function ChallengeOnboardingBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'onboardingSection': (0, _1.ChallengeOnboardingToJSON)(value.onboardingSection),
        'faqs': value.faqs === undefined ? undefined : (value.faqs.map(_1.ChallengeFaqDetailsToJSON)),
    };
}
exports.ChallengeOnboardingBodyToJSON = ChallengeOnboardingBodyToJSON;
